import React from 'react';
import { Clock, CheckCircle, XCircle, FileText } from '../components/Icons';

// Canonical FBR-status badge color + icon, consolidating the near-identical
// getFbrStatusColor/getFbrStatusIcon copies that lived in Invoices.js,
// InvoiceView.js and BatchInvoices.js. Uses the revamp slate palette.

export function getFbrStatusColor(fbrStatus) {
  switch (fbrStatus) {
    case 'submitted': return 'bg-blue-100 text-blue-800';
    case 'approved': return 'bg-green-100 text-green-800';
    case 'rejected': return 'bg-red-100 text-red-800';
    case 'not_submitted': return 'bg-slate-100 text-slate-800';
    default: return 'bg-slate-100 text-slate-800';
  }
}

export function getFbrStatusIcon(fbrStatus) {
  switch (fbrStatus) {
    case 'submitted': return <Clock className="h-4 w-4" />;
    case 'approved': return <CheckCircle className="h-4 w-4" />;
    case 'rejected': return <XCircle className="h-4 w-4" />;
    case 'not_submitted': return <FileText className="h-4 w-4" />;
    default: return <FileText className="h-4 w-4" />;
  }
}
